




































































































































































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '@/config/objectFactory';
import { required } from 'vuelidate/lib/validators';
import { UpdatePartnerProfileRequest, ApiRequest } from '@/types/request';
import { MedTransGoConstants } from '@/util/constants';
import { EventBus } from '@/main';
import { ToastEvent } from '@/types/event';
import { UploadFileResponse, ApiResponse } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import MessageBox from '../../components/MessageBox.vue';
@Component({
    components: {
        MessageBox,
    },
    props: {
        request: Object,
    },
    data() {
        return {
            healthInsurance: {
                npi: '',
                taxIDNumber: '',
                isAgree: '',
                isCredentialedWithMedicare: false,
                medicareCertificate: {
                    filename: '',
                    certificateNumber: '',
                    resourceId: '',
                    uploadedOn: '',
                },
                confirmationDocument: {
                    filename: '',
                    certificateNumber: '',
                    resourceId: '',
                    uploadedOn: '',
                },
                isCredentialedWithMedicaid: false,
                isCredentialedWithOther: false,
                otherHealthInsuranceCompanies: [],
                isConditionAccepted: false,
                isMTGAlternateBiller: false,
            },
            certificate: {
                file: FormData,
                filename: '',
            },
            confirmationDocument: {
                file: FormData,
                filename: '',
            },
        };
    },
    validations() {
        const validations = {
            healthInsurance: {
                npi: {
                    required,
                },
                taxIDNumber: {
                    required,
                },
                isAgree: {
                    required,
                },
                isCredentialedWithMedicare: {
                    required,
                },
                isCredentialedWithMedicaid: {
                    required,
                },
                isCredentialedWithOther: {
                    required,
                },
                otherHealthInsuranceCompanies: {
                    required,
                },
                medicareCertificate: {
                    certificateNumber: {
                        required,
                    },
                },
            },
            certificate: {
                filename: {
                    required,
                },
            },
        };
        const healthInsuranceForm = this as HealthInsuranceForm;
        if (!this.$data.isCredentialedWithMedicare) {
            delete validations.healthInsurance.medicareCertificate.certificateNumber.required;
            delete validations.certificate.filename.required;
        }
        if (!this.$data.isCredentialedWithOther) {
            delete validations.healthInsurance.otherHealthInsuranceCompanies.required;
        }
        if (healthInsuranceForm.sessionInfo.scopes.includes('transporter')) {
            delete validations.healthInsurance.taxIDNumber.required;
            delete validations.healthInsurance.isCredentialedWithMedicaid.required;
        }
        if (healthInsuranceForm.sessionInfo.scopes.includes('homeHealthCare')) {
            delete validations.healthInsurance.isAgree.required;
        }

        return validations;
    },
})
export default class HealthInsuranceForm extends Vue {
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
    private showDeleteConfirmBox = false;
    private type: 'Certificate' | 'ConfirmationDocument' = 'Certificate';
    private mounted() {
        this.getPartnerProfile();
        this.$props.request.isStepHIValid = false;
    }

    private async setDocument($event: any, type: 'Certificate' | 'ConfirmationDocument') {
        const filename = $event.target.files[0].name.toLowerCase();
        if (filename.endsWith('.pdf') || filename.endsWith('.png') ||
            filename.endsWith('.jpeg') || filename.endsWith('.jpg')) {
            if (type === 'Certificate') {
                this.$data.certificate.file = $event.target.files[0];
                this.$data.certificate.filename = $event.target.files[0].name;
            } else {
                this.$data.confirmationDocument.file = $event.target.files[0];
                this.$data.confirmationDocument.filename = $event.target.files[0].name;
            }
        } else {
            const toastEvent: ToastEvent = {
                message: 'File types should be PDF, JPEG, PNG',
                title: 'Invalid file format.',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            const inputName = 'file-input';
            const element = this.$refs[inputName] as any;
            element.reset();
        }
    }
    private async removeDocument() {
        if (this.type === 'Certificate') {
            this.$data.certificate.file = undefined;
            this.$data.certificate.filename = '';
            const inputName = 'file-input';
            const element = this.$refs[inputName] as any;
            element.reset();
        } else {
            this.$data.confirmationDocument.file = undefined;
            this.$data.confirmationDocument.filename = '';
            const inputName = 'file-con';
            const element = this.$refs[inputName] as any;
            element.reset();
        }
        this.showDeleteConfirmBox = false;
    }

    private back() {
        if (this.sessionInfo.scopes.includes('homeHealthCare')) {
            this.$router.push({ name: MedTransGoConstants.VIEW_TRANSPORTATION_QUESTIONNAIRE_NAME });
        } else {
            this.$router.push({ name: MedTransGoConstants.VIEW_DRIVER_INFO_NAME });
        }
    }

    private async uploadFile(file: FormData, baseUrl: string): Promise<ApiResponse<UploadFileResponse>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: baseUrl,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}`,
            data: file,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<UploadFileResponse>(apiRequest);
        if (response.success && response.data) {
            return response;
        } else {
            CommonUtils.showError(response);
            throw new Error(JSON.stringify(response));
        }
    }


    private async getPartnerProfile() {
        const partnerService = ObjectFactory.getPartnerService();
        const response = await partnerService.getPartnerProfile(this.$store.state.serverUrl);
        if (response.data && response.data.transporterProfile && response.data.transporterProfile.healthInsurance) {
            if (response.data.transporterProfile.healthInsurance.confirmationDocument) {
                this.$data.healthInsurance.confirmationDocument =
                    response.data.transporterProfile.healthInsurance.confirmationDocument;
            }
            if (response.data.transporterProfile.healthInsurance.isConditionAccepted) {
                this.$data.healthInsurance.isConditionAccepted =
                    response.data.transporterProfile.healthInsurance.isConditionAccepted;
            }
            if (response.data.transporterProfile.healthInsurance.isCredentialedWithMedicaid) {
                this.$data.healthInsurance.isCredentialedWithMedicaid =
                    response.data.transporterProfile.healthInsurance.isCredentialedWithMedicaid;
            }
            if (response.data.transporterProfile.healthInsurance.isCredentialedWithOther) {
                this.$data.healthInsurance.isCredentialedWithOther =
                    response.data.transporterProfile.healthInsurance.isCredentialedWithOther;
            }
            if (response.data.transporterProfile.healthInsurance.isMTGAlternateBiller) {
                this.$data.healthInsurance.isMTGAlternateBiller =
                    response.data.transporterProfile.healthInsurance.isMTGAlternateBiller;
            }
            if (response.data.transporterProfile.healthInsurance.medicareCertificate) {
                this.$data.healthInsurance.medicareCertificate =
                    response.data.transporterProfile.healthInsurance.medicareCertificate;
            }
            if (response.data.transporterProfile.healthInsurance.npi) {
                this.$data.healthInsurance.npi =
                    response.data.transporterProfile.healthInsurance.npi;
            }
            if (response.data.transporterProfile.healthInsurance.otherHealthInsuranceCompanies) {
                this.$data.healthInsurance.otherHealthInsuranceCompanies =
                    response.data.transporterProfile.healthInsurance.otherHealthInsuranceCompanies;
            }
            if (response.data.transporterProfile.healthInsurance.taxIDNumber) {
                this.$data.healthInsurance.taxIDNumber =
                    response.data.transporterProfile.healthInsurance.taxIDNumber;
            }
            if (response.data.transporterProfile.healthInsurance.isAgree) {
                this.$data.healthInsurance.isAgree = response.data.transporterProfile.healthInsurance.isAgree;

            }
            if (response.data.transporterProfile.healthInsurance.isCredentialedWithMedicare) {
                this.$data.healthInsurance.isCredentialedWithMedicare =
                    response.data.transporterProfile.healthInsurance.isCredentialedWithMedicare;
            }
        }
        if (response.data && !response.data.transporterProfile && response.data.homeHealthCareProfile
            && response.data.homeHealthCareProfile.healthInsurance) {
            if (response.data.homeHealthCareProfile.healthInsurance.confirmationDocument) {
                this.$data.healthInsurance.confirmationDocument =
                    response.data.homeHealthCareProfile.healthInsurance.confirmationDocument;
            }
            if (response.data.homeHealthCareProfile.healthInsurance.isConditionAccepted) {
                this.$data.healthInsurance.isConditionAccepted =
                    response.data.homeHealthCareProfile.healthInsurance.isConditionAccepted;
            }
            if (response.data.homeHealthCareProfile.healthInsurance.isCredentialedWithMedicaid) {
                this.$data.healthInsurance.isCredentialedWithMedicaid =
                    response.data.homeHealthCareProfile.healthInsurance.isCredentialedWithMedicaid;
            }
            if (response.data.homeHealthCareProfile.healthInsurance.isCredentialedWithOther) {
                this.$data.healthInsurance.isCredentialedWithOther =
                    response.data.homeHealthCareProfile.healthInsurance.isCredentialedWithOther;
            }
            if (response.data.homeHealthCareProfile.healthInsurance.isMTGAlternateBiller) {
                this.$data.healthInsurance.isMTGAlternateBiller =
                    response.data.homeHealthCareProfile.healthInsurance.isMTGAlternateBiller;
            }
            if (response.data.homeHealthCareProfile.healthInsurance.medicareCertificate) {
                this.$data.healthInsurance.medicareCertificate =
                    response.data.homeHealthCareProfile.healthInsurance.medicareCertificate;
            }
            if (response.data.homeHealthCareProfile.healthInsurance.npi) {
                this.$data.healthInsurance.npi =
                    response.data.homeHealthCareProfile.healthInsurance.npi;
            }
            if (response.data.homeHealthCareProfile.healthInsurance.otherHealthInsuranceCompanies) {
                this.$data.healthInsurance.otherHealthInsuranceCompanies =
                    response.data.homeHealthCareProfile.healthInsurance.otherHealthInsuranceCompanies;
            }
            if (response.data.homeHealthCareProfile.healthInsurance.taxIDNumber) {
                this.$data.healthInsurance.taxIDNumber =
                    response.data.homeHealthCareProfile.healthInsurance.taxIDNumber;
            }
            if (response.data.homeHealthCareProfile.healthInsurance.isCredentialedWithMedicare) {
                this.$data.healthInsurance.isCredentialedWithMedicare =
                    response.data.homeHealthCareProfile.healthInsurance.isCredentialedWithMedicare;
            }
        }
    }

    private async saveHealthInsuranceForm() {
        if (this.$data.certificate.filename !== '') {
            const formData = new FormData();
            formData.append('file', this.$data.certificate.file);
            const uploadResponse = await this.uploadFile(formData, this.$store.state.serverUrl);
            if (uploadResponse.data) {
                this.$data.healthInsurance.medicareCertificate.resourceId = uploadResponse.data.fileName;
                this.$data.healthInsurance.medicareCertificate.filename = this.$data.certificate.filename;
            }
        }
        if (this.$data.confirmationDocument.filename !== '') {
            const formData = new FormData();
            formData.append('file', this.$data.confirmationDocument.file);
            const uploadResponse = await this.uploadFile(formData, this.$store.state.serverUrl);
            if (uploadResponse.data) {
                this.$data.healthInsurance.confirmationDocument.resourceId = uploadResponse.data.fileName;
                this.$data.healthInsurance.confirmationDocument.filename = this.$data.confirmationDocument.filename;
            }
        }
        const updatePartnerProfileRequest: UpdatePartnerProfileRequest = {};
        if (this.sessionInfo.scopes.includes('transporter')) {
            updatePartnerProfileRequest.transporterProfile = {
                healthInsurance: this.$data.healthInsurance,
            };
        }
        if (this.sessionInfo.scopes.includes('homeHealthCare')) {
            updatePartnerProfileRequest.homeHealthCareProfile = {
                healthInsurance: this.$data.healthInsurance,
            };
        }
        const updatePartnerProfileResponse = await ObjectFactory.getPartnerService()
            .updatePartnerProfile(updatePartnerProfileRequest, this.$store.state.serverUrl);
        if (updatePartnerProfileResponse && this.$route.path.endsWith(MedTransGoConstants.URL_HEALTH_INSURANCE)) {
            const messageBox: any = this.$refs.messageBox;
            messageBox.showModal();
        } else {
            this.$props.request.isStepHIValid = true;
            this.$router.push({ name: MedTransGoConstants.VIEW_UPLOAD_DOCUMENTS_NAME });
        }
    }

    private showDeleteConfirmation(type: 'Certificate' | 'ConfirmationDocument') {
        this.type = type;
        this.showDeleteConfirmBox = true;
    }

    private logout() {
        CommonUtils.logout(this.$store.state);
    }
}
